import {
	IconButton,
	Table,
	TableBody,
	TableCell,
	tableCellClasses,
	TableContainer,
	TableHead,
	TableRow,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import * as React from "react";

import {
	AddRounded,
	DeleteOutlineRounded,
	DoneRounded,
	EditRounded,
} from "@mui/icons-material";
import { useContext, useState } from "react";
import APIContext from "../../context/APIContext";
import ControlContext from "../../context/ControlContext";
import DropdownInput from "../reusable/DropdownInput";
import TextInputField from "../reusable/TextInputField";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: theme.palette.common.black,
		color: theme.palette.common.white,
		padding: 0,
		textAlign: "center",
	},
	[`&.${tableCellClasses.body}`]: {
		fontSize: 12,
		padding: 0,
		textAlign: "center",
	},
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	"&:nth-of-type(odd)": {
		backgroundColor: theme.palette.action.hover,
	},
	// hide last border
	"&:last-child td, &:last-child th": {
		border: 0,
	},
}));

const GoldRetailSalesTable = ({ setgridValues, gridValues }) => {
	let defaultSalesRecord = {
		serial: "",
		trType: "",
		itemCode: "",
		itemDesc: "",
		mcCost: "",
		purity: "",
		mcType: "",
		qty: "",
		grossWgt: "",
		stWgt: "",
		netWgt: "",
		stValue: "",
		mcGm: "",
		rateGm: "",
		totalAmount: "",
	};

	let [salesRecord, setSalesRecord] = useState(defaultSalesRecord);

	//  onChange function for the form values
	const handleChange = (prop) => (event) => {
		setSalesRecord({ ...salesRecord, [prop]: event.target.value });
	};

	let [editting, setEditting] = useState(false);
	let {
		handleAddRecord,
		handleSaveEdit,
		handleEditRecord,
		handleDeleteRecord,
	} = useContext(ControlContext);

	let { mcType, type } = useContext(APIContext);

	return (
		<TableContainer
			sx={{ height: 180, border: "1px solid gray", borderRadius: "5px" }}
		>
			<Table>
				<TableHead>
					<TableRow>
						<StyledTableCell>S#</StyledTableCell>
						<StyledTableCell>Tr.Type</StyledTableCell>
						<StyledTableCell>Item Code</StyledTableCell>
						<StyledTableCell>Item Desc</StyledTableCell>
						<StyledTableCell>McCost</StyledTableCell>
						<StyledTableCell>Purity</StyledTableCell>
						<StyledTableCell>McType</StyledTableCell>
						<StyledTableCell>Qty</StyledTableCell>
						<StyledTableCell>Gross Wgt</StyledTableCell>
						<StyledTableCell>St.Wt </StyledTableCell>
						<StyledTableCell>Net Wt</StyledTableCell>
						<StyledTableCell>St. Value</StyledTableCell>
						<StyledTableCell>MC/Gm </StyledTableCell>
						<StyledTableCell>Rate/Gm </StyledTableCell>
						<StyledTableCell>TotalAmount</StyledTableCell>
						<StyledTableCell></StyledTableCell>
					</TableRow>
					<TableRow>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.serial}
								onChange={handleChange("serial")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<DropdownInput
								options={type}
								value={salesRecord.trType}
								onChange={handleChange("trType")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.itemCode}
								onChange={handleChange("itemCode")}
							/>
						</StyledTableCell>

						<StyledTableCell>
							<TextInputField
								value={salesRecord.itemDesc}
								onChange={handleChange("itemDesc")}
							/>
						</StyledTableCell>

						<StyledTableCell>
							<TextInputField
								value={salesRecord.mcCost}
								onChange={handleChange("mcCost")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.purity}
								onChange={handleChange("purity")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<DropdownInput
								options={mcType}
								value={salesRecord.mcType}
								onChange={handleChange("mcType")}
							/>
						</StyledTableCell>

						<StyledTableCell>
							<TextInputField
								value={salesRecord.qty}
								onChange={handleChange("qty")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.grossWgt}
								onChange={handleChange("grossWgt")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.stWgt}
								onChange={handleChange("stWgt")}
							/>
						</StyledTableCell>

						<StyledTableCell>
							<TextInputField
								value={salesRecord.netWgt}
								onChange={handleChange("netWgt")}
							/>
						</StyledTableCell>

						<StyledTableCell>
							<TextInputField
								value={salesRecord.stValue}
								onChange={handleChange("stValue")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.mcGm}
								onChange={handleChange("mcGm")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.rateGm}
								onChange={handleChange("rateGm")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							<TextInputField
								value={salesRecord.totalAmount}
								onChange={handleChange("totalAmount")}
							/>
						</StyledTableCell>
						<StyledTableCell>
							{!editting ? (
								<IconButton
									onClick={() =>
										handleAddRecord(
											setSalesRecord,
											gridValues,
											setgridValues,
											salesRecord,
											defaultSalesRecord
										)
									}
									color="primary"
									component="label"
								>
									<AddRounded />
								</IconButton>
							) : (
								<IconButton
									onClick={() =>
										handleSaveEdit(
											salesRecord.itemCode,
											setSalesRecord,
											gridValues,
											salesRecord,
											defaultSalesRecord,
											setgridValues,
											setEditting
										)
									}
									color="primary"
									component="label"
								>
									<DoneRounded />
								</IconButton>
							)}
						</StyledTableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					{gridValues.length !== undefined && gridValues.length > 0
						? gridValues.map((row, index) => (
								<StyledTableRow key={index}>
									<StyledTableCell component="th" scope="row">
										{row.serial || index}
									</StyledTableCell>
									<StyledTableCell>{row.trType}</StyledTableCell>
									<StyledTableCell>{row.itemCode}</StyledTableCell>
									<StyledTableCell>{row.itemDesc}</StyledTableCell>
									<StyledTableCell>{row.mcCost}</StyledTableCell>
									<StyledTableCell>{row.purity}</StyledTableCell>
									<StyledTableCell>{row.mcType}</StyledTableCell>
									<StyledTableCell>{row.qty}</StyledTableCell>
									<StyledTableCell>{row.grossWgt}</StyledTableCell>
									<StyledTableCell>{row.stWgt}</StyledTableCell>
									<StyledTableCell>{row.netWgt}</StyledTableCell>
									<StyledTableCell>{row.stValue}</StyledTableCell>
									<StyledTableCell>{row.mcGm}</StyledTableCell>
									<StyledTableCell>{row.rateGm}</StyledTableCell>
									<StyledTableCell>{row.totalAmount}</StyledTableCell>
									<StyledTableCell
										sx={{ display: "flex", alignItems: "center" }}
									>
										<IconButton
											onClick={() =>
												handleEditRecord(
													row.itemCode,
													setSalesRecord,
													gridValues,
													setEditting
												)
											}
											color="secondary"
											component="label"
										>
											<EditRounded sx={{ fontSize: 14 }} />
										</IconButton>
										<IconButton
											onClick={() =>
												handleDeleteRecord(
													row.itemCode,
													gridValues,
													setgridValues,
													setSalesRecord,
													defaultSalesRecord
												)
											}
											color="error"
											component="label"
										>
											<DeleteOutlineRounded sx={{ fontSize: 14 }} />
										</IconButton>
									</StyledTableCell>
								</StyledTableRow>
						  ))
						: null}
				</TableBody>
			</Table>
		</TableContainer>
	);
};

export default GoldRetailSalesTable;
